import PropTypes from 'prop-types';

export const dividerPropTypes = {
	className: PropTypes.string,
	role: PropTypes.string,
	tag: PropTypes.string,
};
